import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { getStatusBarHeight } from "@/utils/statusBarHeight";

var NavBar =
/*#__PURE__*/
function (_Vue) {
  _inherits(NavBar, _Vue);

  function NavBar() {
    _classCallCheck(this, NavBar);

    return _possibleConstructorReturn(this, _getPrototypeOf(NavBar).apply(this, arguments));
  }

  _createClass(NavBar, [{
    key: "clickLeft",
    value: function clickLeft() {}
  }, {
    key: "clickMid",
    value: function clickMid() {}
  }, {
    key: "clickRight",
    value: function clickRight() {}
  }, {
    key: "androidStatusBarHeight",
    get: function get() {
      return getStatusBarHeight();
    }
  }]);

  return NavBar;
}(Vue);

tslib_1.__decorate([Prop({
  default: false
})], NavBar.prototype, "transparent", void 0);

tslib_1.__decorate([Prop({
  default: false
})], NavBar.prototype, "border", void 0);

tslib_1.__decorate([Prop({
  default: false
})], NavBar.prototype, "leftBack", void 0);

tslib_1.__decorate([Prop({
  default: false
})], NavBar.prototype, "leftFork", void 0);

tslib_1.__decorate([Prop({
  default: false
})], NavBar.prototype, "flowLayout", void 0);

tslib_1.__decorate([Prop({
  default: "#fff"
})], NavBar.prototype, "bgColor", void 0);

tslib_1.__decorate([Prop({
  default: 44
})], NavBar.prototype, "height", void 0);

tslib_1.__decorate([Emit("clickLeft")], NavBar.prototype, "clickLeft", null);

tslib_1.__decorate([Emit("clickMid")], NavBar.prototype, "clickMid", null);

tslib_1.__decorate([Emit("clickRight")], NavBar.prototype, "clickRight", null);

NavBar = tslib_1.__decorate([Component({
  components: {// [Tabbar.name]: Tabbar,
  }
})], NavBar);
export default NavBar;